import React from 'react'
import { compose } from 'recompose'
import withStoreTheme from 'store/theme/withStoreTheme'
import withTheme from 'hocs/bases/withTheme'
import { CMS_DEFAULT_IMAGE } from 'helpers/constants'
import CanvasPanel from './builder/components/panel/CanvasPanel'
import CoreEngine from './builder/core/CoreEngine'

const Canvas = compose(
  withStoreTheme(),
  withTheme,
)(
  () => {
    const width = 360
    return (
      <div className="Canvas" style={{ paddingTop: 50 }}>
        <CanvasPanel width={width} open />
        <CoreEngine
          router={null}
          assets={{
            defaultImage: CMS_DEFAULT_IMAGE,
            attributeRule: [],
          }}
        />
      </div>
    )
  },
)

Canvas.propTypes = {}
Canvas.defaultProps = {}

export default Canvas



// WEBPACK FOOTER //
// ./src/components/Canvas/index.js